import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from './client';
import type { Ask, CreateAskRequest, UpdateAskRequest } from '@spi/shared';

export function useCreateAsk(projectId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateAskRequest) =>
      apiFetch<Ask>(`/api/projects/${projectId}/asks`, { method: 'POST', body: JSON.stringify(data) }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['projects', projectId] }),
  });
}

export function useUpdateAsk(projectId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateAskRequest }) =>
      apiFetch<Ask>(`/api/projects/${projectId}/asks/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['projects', projectId] }),
  });
}

export function useCancelAsk(projectId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) =>
      apiFetch(`/api/projects/${projectId}/asks/${id}`, { method: 'DELETE' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['projects', projectId] }),
  });
}
